import { render, staticRenderFns } from "./RunHistoryTable.vue?vue&type=template&id=f5a68e56&scoped=true"
import script from "./RunHistoryTable.vue?vue&type=script&lang=ts"
export * from "./RunHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./RunHistoryTable.vue?vue&type=style&index=0&id=f5a68e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a68e56",
  null
  
)

export default component.exports